import { LocalAuth } from "@core/model/local-auth";
import { LocalProfile } from "@core/model/local-profile";
import { LocalRole } from "@core/model/local-role.enum";
import { LocalRoleIdentity } from "@core/model/local-role-identity";
import { decodeJwt } from "@core/utility/jwt-decode";
import { AUTH, PROFILE } from "@core/utility/settings";
import StorageService from "@shared/services/storage.service";
import { useCallback } from "react";

export function useUserIdentity() {
  const getUser = useCallback(
    () => StorageService.load<LocalProfile>(PROFILE),
    []
  );

  const getAuthUser = useCallback(
    () => StorageService.load<LocalAuth>(AUTH),
    []
  );

  const getUserTokenEntity = useCallback(() => {
    const user = StorageService.load<LocalAuth>(AUTH);
    if (!user) return false;

    return decodeJwt(user.accessToken);
  }, []);

  const getUserRole = useCallback(() => {
    const entity = getUserTokenEntity() as any;

    return entity.roles as LocalRoleIdentity;
  }, []);

  const userRoleIsAdmin = useCallback(() => {
    const entity = getUserTokenEntity() as any;

    const userRole = entity.roles as LocalRoleIdentity;
    return userRole?.name.toUpperCase() === LocalRole.Admin;
  }, []);

  return {
    getUser,
    getUserRole,
    getUserTokenEntity,
    getAuthUser,
    userRoleIsAdmin,
  };
}
